//GeneratorFlag:[NoChange]
export default {
	path: 'person-military',
	name: 'hub.basis.personMilitary.layout',
	redirect: to => {
		return {name: 'hub.personMilitary.list'};
	},
	component: () => import('@/modules/hub/views/layout.vue'),
	meta: {
		requiresAuth: true,
		serverAccessKeys:[],
		clientAccessKeys:["/hub/basis/person-military"],
		resourceKey: 'hub.personMilitaryLayout',
		menuConfig: {
			isVisible: true,
			iconName: 'bi-link-45deg',
		}
	},
	children: [
//GeneratorFlag:[PersonMilitaryCreate]"
		{
			path: 'create',
			name: 'hub.personMilitary.create',
			component: () => import('@/modules/hub/views/person-military/person-military-create.vue'),
			meta: {
				requiresAuth: true,
				resourceKey: 'hub.personMilitaryCreate',
				clientAccessKeys:["/hub/basis/person-military/create"],
				serverAccessKeys:["/hub/person-military/create","/hub/person-military/stream-create"],
				menuConfig: {
					isVisible: false
				}
			}
		},
//GeneratorFlag:[PersonMilitaryCreateImport]"
		{
			path: 'create-import',
			name: 'hub.personMilitary.createImport',
			component: () => import('@/modules/hub/views/person-military/person-military-create-import.vue'),
			meta: {
				requiresAuth: true,
				resourceKey: 'hub.personMilitaryCreateImport',
				clientAccessKeys:["/hub/basis/person-military/create-import"],
				serverAccessKeys:["/hub/person-military/create","/hub/person-military/stream-create"],
				menuConfig: {
					isVisible: false
				}
			}
		},
//GeneratorFlag:[PersonMilitaryDelete]"
		{
			path: 'delete',
			name: 'hub.personMilitary.delete',
			component: () => import('@/modules/hub/views/person-military/person-military-delete.vue'),
			meta: {
				requiresAuth: true,
				resourceKey: 'hub.personMilitaryDelete',
				clientAccessKeys:["/hub/basis/person-military/delete"],
				serverAccessKeys:["/hub/person-military/delete","/hub/person-military/stream-delete"],
				menuConfig: {
					isVisible: false
				}
			}
		},
//GeneratorFlag:[PersonMilitaryDetail]"
		{
			path: 'detail',
			name: 'hub.personMilitary.detail',
			component: () => import('@/modules/hub/views/person-military/person-military-detail.vue'),
			meta: {
				requiresAuth: true,
				resourceKey: 'hub.personMilitaryDetail',
				clientAccessKeys:["/hub/basis/person-military/detail"],
				serverAccessKeys:["/hub/person-military/detail"],
				menuConfig: {
					isVisible: false
				}
			}
		},
//GeneratorFlag:[PersonMilitaryList]"
		{
			path: 'list',
			name: 'hub.personMilitary.list',
			component: () => import('@/modules/hub/views/person-military/person-military-list.vue'),
			meta: {
				requiresAuth: true,
				resourceKey: 'hub.personMilitaryList',
				clientAccessKeys:["/hub/basis/person-military/list"],
				serverAccessKeys:["/hub/person-military/list"],
				menuConfig: {
					isVisible: false
				}
			}
		},
//GeneratorFlag:[PersonMilitaryAttachment]"
		{
			path: 'attachment',
			name: 'hub.personMilitary.attachment',
			component: () => import('@/modules/hub/views/person-military/person-military-attachment.vue'),
			meta: {
				requiresAuth: true,
				resourceKey: 'hub.personMilitaryAttachment',
				clientAccessKeys:["/hub/basis/person-military/attachment"],
				serverAccessKeys:["/hub/person-military/list"],
				menuConfig: {
					isVisible: false
				}
			}
		},
//GeneratorFlag:[PersonMilitaryUpdate]"
		{
			path: 'update',
			name: 'hub.personMilitary.update',
			component: () => import('@/modules/hub/views/person-military/person-military-update.vue'),
			meta: {
				requiresAuth: true,
				resourceKey: 'hub.personMilitaryUpdate',
				clientAccessKeys:["/hub/basis/person-military/update"],
				serverAccessKeys:["/hub/person-military/update"],
				menuConfig: {
					isVisible: false
				}
			}
		},
//GeneratorFlag:[NewRoute]
	]
}